import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M38.6601 4.35994C42.5201 7.46994 46.1801 14.97 41.9501 30.25C37.7101 45.53 20.9401 62.56 5.31006 54.31C5.31006 54.31 14.2801 55.23 14.2501 42.62C14.2301 30 13.1301 16.26 19.7001 7.87996C26.2601 -0.500038 35.2701 1.61994 38.6601 4.35994Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.42004 55.2099C8.42004 55.2099 17.78 55.9399 20.48 45.7999C24.99 28.7899 22.02 8.63994 32.76 4.18994C32.76 4.18994 34.14 9.69993 32.81 25.5499C31.93 36.0799 27.14 57.5299 11.56 56.0399"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
